/* eslint-disable */
import { useMutation } from "@apollo/client";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
  useTheme,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { usePopup } from "../../context/commonPop";
import { GET_BLOG, GET_GEMINI_BLOG } from "../../gql/utils";
import MainLoader from "../MainLoader/MainLoader";
import GetBlog from "./GetBlog";
import { countFocusKeyword, countFocusKeywordAddon } from "./utils";
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  display: "flex",
  // alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  padding: "30px 0",
}));
const FormWrapper = styled("div")(({ theme }) => ({
  flex: 1,
  "& form": {
    marginBottom: "0",
  },
  "& .TableMainHeading": {
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: "35px",
  },
  "& .titleWrapper ": {
    marginTop: "20px",
  },
  "& .titleWrapper h3": {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "17px",
    marginBottom: "10px",
  },
  "& .titleWrapper body1": {
    pointerEvents: "none",
  },
  "& table.KewordTableWrapperBlog tbody tr td": {
    color: theme.palette.text.primary,
    fontSize: "15px",
    padding: "0px 16px !important",
  },
  "& table.KewordTableWrapperBlog tbody tr td label span": {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  "& table.KewordTableWrapperBlog thead tr th": {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: "15px",
  },
  "& table.KewordTableWrapperBlog .selectTitleTableHead tr th": {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: "15px",
    padding: "5px 20px !important",
  },
  "& .addonKeywords": {
    padding: "20px 0",
    "& h3": {
      color: theme.palette.text.primary,
      fontWeight: 600,
      fontSize: "17px",
    },
  },
  "& h2": {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
    "& .submitBlogBtn": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "10px 20px",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
  },
}));

function GenerateBlogs() {
  const location = useLocation();
  const theme = useTheme();
  const {
    state: { projectId, selectedTitleInfo, keywords, generator },
  } = location || {};

  const { handleOpen } = usePopup();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFocus, setSelectedFocus] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState([]);
  const [blogCount, setBlogCount] = useState(100);
  const [htmlDataGPT, setHtmlDataGPT] = useState({ text_html: "", word_count: null });
  const [htmlDataGemini, setHtmlDataGemini] = useState({ text_html: "", word_count: null });
  const [getGeneratedBlog] = useMutation(GET_BLOG);
  const [getGeneratedGeminiBlog] = useMutation(GET_GEMINI_BLOG);
  const [selectedFocusCount, setSelectedFocusCount] = useState({ gpt: 0, gemini: 0 });
  const [selectedFocusCountAddon, setSelectedFocusCountAddon] = useState({ gptAddon: 0, geminiAddon: 0 });
  const [selectedFocusKeywords, setSelectedFocusKeywords] = useState([]);
  const customizer = useSelector(state => state.customizer);
  const targetDivRef = useRef(null);
  const handleChange = event => {
    const selectedValue = event.target.value;
    if (!selectedFocus.includes(selectedValue)) {
      setSelectedFocusKeywords([...selectedFocus, selectedValue]);
    }
  };

  const handleAdvanceClick = () => {
    const pathname = `/urlKeywords/advance-keywords?menu=headerKeywords`;
    const state = {
      title: title,
      focusKeyword: selectedFocus,
      selectedFocusKeywords: selectedFocusKeywords,
      projectId: projectId,
    };
    navigate(pathname, { state: state });
  };

  const handleCheckboxChange = (event, keyword) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedAddon(prevAddons => [...prevAddons, keyword.keyword]);
    } else {
      setSelectedAddon(prevAddons => prevAddons.filter(item => item !== keyword.keyword));
    }
  };
  const handleBlogCountChange = e => {
    const newValue = Math.min(Math.max(parseInt(e.target.value, 10), 100), 2000);
    setBlogCount(newValue);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    const blogInput = {
      title,
      focusKeyword: selectedFocus.length > 0 ? selectedFocus.join(", ") : selectedFocusKeywords,
      addonKeywords: selectedAddon.length > 0 ? selectedAddon.join(", ") : "",
      blogCount,
    };
    try {
      if (selectedFocus.length === 0 && selectedFocusKeywords.length === 0) {
        throw new Error("please select the focus keyword");
      }
      // if (generator === "GPT") {
      const { data } = await getGeneratedBlog({ variables: { blogInput } });
      const blogResponse = data?.generateBlog;
      const blogHtml = typeof blogResponse === 'string' ? blogResponse : blogResponse?.text_html;
      const wordCount = typeof blogResponse === 'string' ? null : blogResponse?.word_count;
      if (!blogHtml) {
        throw new Error("No blog content returned");
      }
      setHtmlDataGPT({ text_html: blogHtml, word_count: wordCount  });
      const gptCount = countFocusKeyword(blogHtml, selectedFocus.length > 0 ? selectedFocus : selectedFocusKeywords);
      const gptCountAddon = countFocusKeywordAddon(blogHtml, selectedAddon);
      setSelectedFocusCount({ gpt: gptCount || 0, gemini: 0 });
      setSelectedFocusCountAddon({ gptAddon: gptCountAddon || 0, geminiAddon: 0 });
      setTimeout(() => {
        targetDivRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
      // }
      // else if (generator === "Gemini") {
      //   const { data } = await getGeneratedGeminiBlog({ variables: { blogInput } });
      //   const { generated_content, generated_words_count } = data?.generateGeminiBlog || {};
      //   setHtmlDataGemini({ text_html: generated_content, word_count: generated_words_count });
      //   const geminiCount = countFocusKeyword(generated_content, selectedFocus.length > 0 ? selectedFocus : selectedFocusKeywords);
      //   const geminiCountAddon = countFocusKeywordAddon(generated_content, selectedAddon);
      //   setSelectedFocusCount({ gpt: 0, gemini: geminiCount || 0 });
      //   setSelectedFocusCountAddon({ gptAddon: 0, geminiAddon: geminiCountAddon || 0 });
      // } else if (generator === "Both") {
      //   const blogResult = getGeneratedBlog({ variables: { blogInput } });
      //   const geminiBlogResult = getGeneratedGeminiBlog({ variables: { blogInput } });

      //   const [blogData, geminiBlogData] = await Promise.all([blogResult, geminiBlogResult]);

      //   setHtmlDataGPT({
      //     text_html: blogData.data?.generateBlog.text_html,
      //     word_count: blogData.data?.generateBlog.word_count,
      //   });

      //   setHtmlDataGemini({
      //     text_html: geminiBlogData.data?.generateGeminiBlog.generated_content,
      //     word_count: geminiBlogData.data?.generateGeminiBlog.generated_words_count,
      //   });

      //   const gptCount =
      //     blogData &&
      //     blogData.data?.generateBlog.text_html &&
      //     countFocusKeyword(blogData.data?.generateBlog.text_html, selectedFocus.length > 0 ? selectedFocus : selectedFocusKeywords);
      //   const geminiCount =
      //     geminiBlogData &&
      //     geminiBlogData.data?.generateGeminiBlog.generated_content &&
      //     countFocusKeyword(geminiBlogData.data?.generateGeminiBlog.generated_content, selectedFocus.length > 0 ? selectedFocus : selectedFocusKeywords);

      //   const gptCountAddon = blogData.data?.generateBlog.text_html && countFocusKeywordAddon(blogData.data?.generateBlog.text_html, selectedAddon);
      //   const geminiCountAddon =
      //     geminiBlogData.data?.generateGeminiBlog.generated_content && countFocusKeywordAddon(geminiBlogData.data?.generateGeminiBlog.generated_content, selectedAddon);

      //   setSelectedFocusCount({ gpt: gptCount, gemini: geminiCount });
      //   setSelectedFocusCountAddon({ gptAddon: gptCountAddon, geminiAddon: geminiCountAddon });
      // }
    } catch (error) {
      console.error("Error occurred:", error);
      handleOpen(true, error.message || "Something went wrong , Data not fetch");
    }

    setIsLoading(false);
  };
  useEffect(() => {
    if (selectedTitleInfo?.title) {
      setTitle(selectedTitleInfo.title.replace(/^"|"$/g, ""));
    }
    if (selectedTitleInfo?.focusKeyword) {
      let keywords;
      if (Array.isArray(selectedTitleInfo.focusKeyword)) {
        keywords = selectedTitleInfo.focusKeyword;
      } else {
        keywords = selectedTitleInfo.focusKeyword.split(",").map(keyword => keyword.trim());
      }
      setSelectedFocus(keywords);
    }
    if (selectedTitleInfo?.addonKeywords) {
      const keywords = Array.isArray(selectedTitleInfo.addonKeywords) ? selectedTitleInfo.addonKeywords : selectedTitleInfo.addonKeywords.split(",").map(keyword => keyword.trim());
      setSelectedAddon(keywords);
    }
  }, [selectedTitleInfo]);
  useEffect(() => {
    setSelectedAddon(keywords.map(keyword => keyword.keyword));
  }, [keywords]);

  return isLoading ? (
    <MainLoader message="Loading" />
  ) : (
    <>
      <SectionWrapper>
        <Container maxWidth="">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Card sx={{ padding: { xs: "15px 15px 50px 15px", sm: "30px 40px 24px 40px" }, border: `1px solid ${theme.palette.divider}`, boxShadow: "none" }}>
                  <FormWrapper>
                    <Typography component="h2" className="TableMainHeading">
                      Generate Your Blog Here
                    </Typography>
                    <form onSubmit={handleSubmit}>
                      <Box className="titleWrapper">
                        <Typography component="h3">Title:</Typography>
                        <Typography component="body1">{title}</Typography>
                      </Box>
                      <Divider sx={{ my: "15px" }} />
                      {selectedFocus.length > 0 ? (
                        <Box className="titleWrapper">
                          <Typography component={"h3"}>Focus Keyword:</Typography>
                          <Typography component={"body1"}>{selectedFocus ? selectedFocus?.join(", ") : selectedFocusKeywords}</Typography>{" "}
                        </Box>
                      ) : (
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Focus Keyword</InputLabel>
                          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={selectedFocusKeywords} label="FocusKeyword" onChange={handleChange}>
                            {keywords.map((keyword, item) => (
                              <MenuItem value={keyword.keyword}>{keyword.keyword}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      <Divider sx={{ my: "15px" }} />

                      <Box className="addonKeywords">
                        <Typography component="h3" sx={{ marginBottom: "16px" }}>
                          Addon Keywords
                        </Typography>

                        <TableContainer style={{ maxHeight: 440, overflow: "auto" }}>
                          <Table
                            className="KewordTableWrapperBlog"
                            sx={{
                              border: customizer?.activeMode === "dark" ? "1px solid #333F55" : "1px solid #e5eaef",
                            }}
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Keywords</TableCell>
                                <TableCell>Monthly Searches</TableCell>
                                <TableCell>Competition</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {keywords.length > 0 &&
                                keywords
                                  .filter(keyword => {
                                    if (selectedTitleInfo?.focusKeyword) {
                                      const focusVariants = selectedTitleInfo.focusKeyword
                                        .toLowerCase()
                                        .split(", ")
                                        .map(keyword => keyword.trim());
                                      return !focusVariants.some(variant => keyword.keyword.toLowerCase() === variant) && !selectedFocus.includes(keyword.keyword);
                                    } else {
                                      return !selectedFocusKeywords.includes(keyword.keyword);
                                    }
                                  })
                                  .map(kw => (
                                    <TableRow>
                                      <TableCell>{kw.keyword}</TableCell>
                                      <TableCell>{kw.monthly_searches}</TableCell>
                                      <TableCell>{kw.competition}</TableCell>
                                      <TableCell>
                                        <Checkbox disabled={true} checked={true} onChange={event => handleCheckboxChange(event, kw)} />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>

                      <TextField
                        label="Word Count"
                        variant="outlined"
                        type="number"
                        fullWidth
                        value={blogCount}
                        onChange={handleBlogCountChange}
                        margin="normal"
                        inputProps={{ min: 100, max: 2000 }}
                      />
                      <Box className="BtnWrapper">
                        <Button className="submitBlogBtn" type="submit">
                          Submit
                        </Button>
                        <Button className="submitBlogBtn" onClick={handleAdvanceClick}>
                          Advance Option
                        </Button>
                      </Box>
                    </form>
                  </FormWrapper>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </SectionWrapper>
      <Box ref={targetDivRef}>
        {htmlDataGPT && htmlDataGPT.text_html && (
          <GetBlog
            htmlData={htmlDataGPT}
            heading={title || "GPT Blog"}
            projectId={projectId}
            selectedFocus={selectedFocus}
            selectedFocusKeywords={selectedFocusKeywords}
            MetaTableRows={[
              { id: 1, type: "Focus Keyword", count: selectedFocusCount?.gpt || 0 },
              { id: 2, type: "Addon Keyword", count: selectedFocusCountAddon?.gptAddon || 0 },
            ]}
            selectedAddon={selectedAddon}
          />
        )}
        {htmlDataGemini && htmlDataGemini.text_html && (
          <GetBlog
            htmlData={htmlDataGemini}
            selectedFocus={selectedFocus}
            projectId={projectId}
            selectedFocusKeywords={selectedFocusKeywords}
            heading={title || "Gemini Blog"}
            MetaTableRows={[
              { id: 1, type: "Focus Keyword", count: selectedFocusCount?.gemini || 0 },
              { id: 2, type: "Addon Keyword", count: selectedFocusCountAddon?.geminiAddon || 0 },
            ]}
            selectedAddon={selectedAddon}
          />
        )}
      </Box>
    </>
  );
}

export default GenerateBlogs;
